export default "__VITE_ASSET__CFOAiH9f__"